<template>
  <a-modal
    ref="modalRef"
    :visible="editorPopups.popupVisible(PopupType['sendTutorial'])"
    :wrap-style="{ 'pointer-events': 'none', overflow: 'hidden' }"
    wrap-class-name="send-tutorial-picker-popup"
    :width="276"
    :mask="false"
    :mask-closable="false"
    :footer="null"
    @cancel="editorPopups.togglePopup(PopupType['sendTutorial'])"
  >
    <div ref="modalBodyRef">
      <video
        src="https://watchface-editor-release.cnbj1.mi-fds.com/watchface-editor-release/videos/表盘文件传输至固件操作.mp4"
        controls
        muted
        preload="auto"
        class="max-h-[70vh] w-full"
      />
    </div>
    <template #title>
      <div
        ref="modalTitleRef"
        class="absolute left-0 top-0 w-full h-full cursor-move flex items-center px-2 text-sm"
        style=""
      >
        固件端预览 - 教学视频
      </div>
    </template>
    <template #modalRender="{ originVNode }">
      <div :style="transformStyle">
        <component :is="originVNode" />
      </div>
    </template>
  </a-modal>
</template>

<script lang="ts" setup>
import { PopupType, useEditorPopups } from '@/hooks/use-editor-popups';
import { useDraggable } from '@vueuse/core';
import { computed, ref, watch, watchEffect } from 'vue';
const editorPopups = useEditorPopups();

const modalTitleRef = ref<HTMLDivElement | null>(null);
const modalBodyRef = ref<HTMLDivElement | null>(null);
const { x, y, isDragging } = useDraggable(modalTitleRef);
const startX = ref(0);
const startY = ref(0);
const startedDrag = ref(false);
const transformX = ref(0);
const transformY = ref(0);
const preTransformX = ref(0);
const preTransformY = ref(0);
const dragRect = ref({
  left: 0,
  right: 0,
  top: 0,
  bottom: 0
});
watch([x, y], () => {
  if (!modalTitleRef.value || !modalBodyRef.value) return;
  if (!startedDrag.value) {
    startX.value = x.value;
    startY.value = y.value;
    const bodyRect = document.body.getBoundingClientRect();
    const modalTitleRect = modalTitleRef.value.getBoundingClientRect();
    const modalBodyRect = modalBodyRef.value.getBoundingClientRect();
    dragRect.value.right = bodyRect.width - modalTitleRect.width;
    dragRect.value.bottom =
      bodyRect.height - (modalTitleRect.height + modalBodyRect.height);
    preTransformX.value = transformX.value;
    preTransformY.value = transformY.value;
  }
  startedDrag.value = true;
});
watch(isDragging, () => {
  if (!isDragging) {
    startedDrag.value = false;
  }
});
watchEffect(() => {
  if (startedDrag.value) {
    transformX.value =
      preTransformX.value +
      Math.min(Math.max(dragRect.value.left, x.value), dragRect.value.right) -
      startX.value;
    transformY.value =
      preTransformY.value +
      Math.min(Math.max(dragRect.value.top, y.value), dragRect.value.bottom) -
      startY.value;
  }
});
const transformStyle = computed(() => {
  return {
    transform: `translate(${transformX.value}px, ${transformY.value}px)`
  };
});
// 每次打开时 重置到初始位置
watch(
  () => editorPopups.popupVisible(PopupType['sendTutorial']),
  (val: boolean) => val && ([transformX.value, transformY.value] = [0, 0])
);
</script>
<style lang="less">
.send-tutorial-picker-popup {
  .ant-modal-content {
    border-radius: 10px !important;
    background-color: #000000;
    .ant-modal-header {
      height: 2rem !important;
      padding: 0.5rem;
      position: relative;
      border-radius: 10px 10px 0 0;
      background-color: #000000;
      .ant-modal-title {
        font-size: 0;
      }
    }
    .ant-modal-body {
      padding: 0;
    }
    .ant-modal-close-x {
      width: 0 !important;
      height: 0 !important;
      transform: translate(-16px, 16px) !important;
    }
  }
}
</style>
